import { render, staticRenderFns } from "./VaimoIcon.vue?vue&type=template&id=1171a1f4&scoped=true&"
import script from "./VaimoIcon.vue?vue&type=script&lang=ts&"
export * from "./VaimoIcon.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoIcon.vue?vue&type=style&index=0&id=1171a1f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1171a1f4",
  null
  
)

export default component.exports